import React, { useState } from "react";
import { createTimeValue } from "../../../provider/adm/profesores/BankData/TimeValue/createTimeValue";
import { updateTimeValue } from "../../../provider/adm/profesores/BankData/TimeValue/updateTimeValue";
import { Button } from "../../ui/button";
import {
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../ui/dialog";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

const CrearEditarTimeValue = ({ fetchTimeValues, setLoading,data, context }) => {
    const formatNumber = (value) => {
        if (!value) return "";
        // Remove non-digit characters
        const number = value.toString().replace(/\D/g, "");
        // Format with thousands separator
        return new Intl.NumberFormat('es-CO').format(number);
    };
    const [name, setName] = useState(data.name || "");
    const [virtualHourValue, setVirtualHourValue] = useState(formatNumber(data.virtualHourValue) || "");
    const [inpersonHourValue, setInpersonHourValue] = useState(formatNumber(data.inpersonHourValue) || "");
    const [virtualHourCancelledValue, setVirtualHourCancelledValue] = useState(formatNumber(data.virtualHourCancelledValue) || "");
    const [inpersonHourCancelledValue, setInpersonHourCancelledValue] = useState(formatNumber(data.inpersonHourCancelledValue) || "");
    const parseNumber = (formattedValue) => {
        if (!formattedValue) return 0;
        return parseInt(formattedValue.replace(/\D/g, ""), 10);
    };

    const handleCreateUpdateTimeValue = async () => {
        setLoading(true);
        const timeValueData = {
            name,
            virtualHourValue: parseNumber(virtualHourValue),
            inpersonHourValue: parseNumber(inpersonHourValue),
            virtualHourCancelledValue: parseNumber(virtualHourCancelledValue),
            inpersonHourCancelledValue: parseNumber(inpersonHourCancelledValue),
        };

        if (!timeValueData.name || !timeValueData.virtualHourValue || !timeValueData.inpersonHourValue) {
            alert("Nombre y valores de hora son requeridos.");
            setLoading(false);
            return;
        }

        try {
            if (context === "crear") {
                await createTimeValue(timeValueData);
            } else {
                await updateTimeValue(timeValueData, data.id);
            }
        } catch (error) {
            console.error("Error creating/updating time value:", error);
        } finally {
            fetchTimeValues(); 
            setLoading(false);  // Refresh the time values after creation or update
        }
    };

    return (
        <>
            <DialogHeader>
                <DialogTitle>{context === "crear" ? "Crear" : "Editar"} Nómina</DialogTitle>
                <DialogDescription>
                    {context === "crear" ? "Crear una nueva" : "Editar la"} configuración de nómina
                </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="name" className="text-right">
                        Nombre
                    </Label>
                    <Input
                        id="name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="col-span-3"
                        placeholder="Nombre de la nómina"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="virtualHourValue" className="text-right">
                        Valor hora virtual
                    </Label>
                    <Input
                        id="virtualHourValue"
                        type="character"
                        value={virtualHourValue}
                        onChange={(e) => setVirtualHourValue(formatNumber(e.target.value))}
                        className="col-span-3"
                        placeholder="0"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="inpersonHourValue" className="text-right">
                        Valor hora presencial
                    </Label>
                    <Input
                        id="inpersonHourValue"
                        type="character"
                        value={inpersonHourValue}
                        onChange={(e) => setInpersonHourValue(formatNumber(e.target.value))}
                        className="col-span-3"
                        placeholder="0"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="virtualHourCancelledValue" className="text-right">
                        Valor hora virtual cancelada
                    </Label>
                    <Input
                        id="virtualHourCancelledValue"
                        type="character"
                        value={virtualHourCancelledValue}
                        onChange={(e) => setVirtualHourCancelledValue(formatNumber(e.target.value))}
                        className="col-span-3"
                        placeholder="0"
                    />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="inpersonHourCancelledValue" className="text-right">
                        Valor hora presencial cancelada
                    </Label>
                    <Input
                        id="inpersonHourCancelledValue"
                        type="character"
                        value={inpersonHourCancelledValue}
                        onChange={(e) => setInpersonHourCancelledValue(formatNumber(e.target.value))}
                        className="col-span-3"
                        placeholder="0"
                    />
                </div>
            </div>
            <DialogFooter>
                <Button type="button" variant="ghost" onClick={handleCreateUpdateTimeValue}>
                    Guardar cambios
                </Button>
            </DialogFooter>
        </>
    );
};

export default CrearEditarTimeValue;